import { render, staticRenderFns } from "./BuyerPhone.vue?vue&type=template&id=61ecc780&scoped=true&"
var script = {}
import style0 from "./BuyerPhone.vue?vue&type=style&index=0&id=61ecc780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ecc780",
  null
  
)

export default component.exports